export default __webpack_public_path__ + "static/dm-a87ef3072bee60985f03ad1c86503c7d.svg";